import { call, put, select, takeLatest, takeLeading } from 'redux-saga/effects';

import { dsToast } from 'src/component/ds/ui/sonner';
import { getTranslation } from 'src/i18n/translations';
import * as deviceListApi from 'src/service/api/deviceList';
import downloadCsv from 'src/utils/downloadCsv';
import { getFacilityName } from '../authentication/selector';
import * as deviceListActions from './action';
import { getDeviceListState } from './selector';

export function * deviceListRoot () {
  yield takeLatest([deviceListActions.FETCH_DEVICE_LIST, deviceListActions.FETCH_DEVICE_LIST_NEXT_PAGE], fetchPage);
  yield takeLeading(deviceListActions.EXPORT_DEVICE_LIST, exportList);
}

function * fetchPage (action) {
  const state = yield select(getDeviceListState);

  try {
    const page = yield call(deviceListApi.getDeviceList, action, state.get('query'), state.get('nextOffset'));
    yield put(deviceListActions.fetchDeviceListSuccess(page));
  } catch (err) {
    yield put(deviceListActions.fetchDeviceListFailed(err));
  }
}

function * exportList (action) {
  const state = yield select(getDeviceListState);
  const facilityName = yield select(getFacilityName);
  // The browser's request-cancel handle (not a device controller): the toast's Cancel aborts the export request.
  const controller = new AbortController();
  const preparing = dsToast.loading(
    getTranslation('deviceList.export.preparing.title'),
    getTranslation('deviceList.export.preparing.description'),
    { action: { label: getTranslation('deviceList.export.cancel'), onClick: () => controller.abort() } }
  );

  try {
    const csv = yield call(deviceListApi.getDeviceListExport, action, state.get('query') ?? {}, controller.signal);
    downloadCsv(csv, facilityName, 'devices');
    yield put(deviceListActions.exportDeviceListSuccess());
    dsToast.close(preparing);
    dsToast.success(getTranslation('deviceList.export.ready.title'), getTranslation('deviceList.export.ready.description'));
  } catch (err) {
    dsToast.close(preparing);
    if (controller.signal.aborted) {
      yield put(deviceListActions.exportDeviceListCancelled());
      return;
    }
    yield put(deviceListActions.exportDeviceListFailed(err));
    dsToast.error(getTranslation('deviceList.export.failed.title'), getTranslation('deviceList.export.failed.description'));
  }
}
